import Box from "@mui/material/Box";
import {
  DndContext,
  DragEndEvent,
  PointerSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
  closestCenter,
} from "@dnd-kit/core";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useAppStore } from "../../store";
import { StackCard } from "./StackCard";

export function StackList() {
  const { assessment, viewMode, reorderStacks } = useAppStore();

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  const handleStackDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const activeId = String(active.id);
    const overId = String(over.id);

    // Parse IDs: stack:stackId
    if (!activeId.startsWith("stack:") || !overId.startsWith("stack:")) return;

    const activeStackId = activeId.replace("stack:", "");
    const overStackId = overId.replace("stack:", "");

    const fromIndex = assessment.stacks.findIndex(
      (s) => s.id === activeStackId,
    );
    const toIndex = assessment.stacks.findIndex((s) => s.id === overStackId);

    if (fromIndex !== -1 && toIndex !== -1) {
      reorderStacks(fromIndex, toIndex);
    }
  };

  const stackIds = assessment.stacks.map((stack) => `stack:${stack.id}`);

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleStackDragEnd}
    >
      <SortableContext
        items={stackIds}
        strategy={horizontalListSortingStrategy}
      >
        <Box
          sx={{
            display: "flex",
            gap: 2,
            overflowX: "auto",
            pb: 2,
            minHeight: "calc(100vh - 140px)",
          }}
        >
          {assessment.stacks.map((stack) => (
            <StackCard key={stack.id} stack={stack} viewMode={viewMode} />
          ))}
        </Box>
      </SortableContext>
    </DndContext>
  );
}
